module.exports = __webpack_public_path__ + "static/media/publicsonar_infrastructure_selected.bb2faac7.svg";